import { Box } from "@chakra-ui/react";
import TimerBox from "./components/TimerBox";
import TimerTable from "./components/TimerTable";
import { useTimerTracker } from "./hooks/useTimeTracker";

const TimeTrackerScreen = () => {

    const {
        state,
        loadTasks,
        switchType,
        confirmTimer,
        changeInput,
        changeSelects,
        deleteTimerExec,
        displayInputError
    } = useTimerTracker();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <TimerBox
                state={state}
                loadTasks={loadTasks}
                switchType={switchType}
                confirmTimer={confirmTimer}
                changeInput={changeInput}
                changeSelects={changeSelects}
                displayInputError={displayInputError}
            />

            <TimerTable
                state={state}
                deleteTimerExec={deleteTimerExec}
            />
        </Box>
    )
}
export default TimeTrackerScreen;